module.exports = __webpack_public_path__ + "static/media/profile.262d5099.svg";